import React, { Component } from 'react';
import HomePageTable from '../home/HomePageTable';

class homePage extends Component {
  render() {
    return (
      <div className="content">
        <HomePageTable />
      </div>
    );
  }
}

export default homePage;
